import { useCallback } from 'react'
import styled from 'astroturf/react'
const errorColor = 'var(--color-error, #C84545)'
const colorSurfaceActionSecondary = 'var(--colorSurfaceActionSecondary, var(--coreColorBlue100))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

import { useBooleanState } from 'hooks/useBooleanState'

import EditView from './edit_view'
import NormalView from './normal_view'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/fields/guest/tag/index.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    'data-container': `guest-email-${props.isInvalid ? 'invalid' : 'valid'}`
  })
})

const Tag = ({
  id,
  className,
  name,
  onChange,
  onDelete,
  isValid,
  tagInputRef
}) => {
  const [isEditMode, setEditView, setNormalView] = useBooleanState(false)

  const handleDelete = useCallback(() => {
    onDelete(id)
    tagInputRef.current.focus()
  }, [onDelete, tagInputRef, id])

  return (
    <Container
      isEditMode={isEditMode}
      className={className}
      isInvalid={!isValid}
    >
      {
        isEditMode
          ? (
            <EditView
              name={name}
              toggleView={setNormalView}
              onChange={onChange}
            />
          )
          : (
            <NormalView
              name={name}
              onDelete={handleDelete}
              toggleView={setEditView}
              isInvalid={!isValid}
            />
          )
      }
    </Container>
  )
}

export default Tag
